module.exports = __webpack_public_path__ + "static/media/builtinv2-Domofone 2.6bd6ff77.png";